import React, { JSXElementConstructor, ReactElement, ReactNode, ReactPortal } from 'react'
import { MuiThemeProvider, ThemeProviderProps } from "@material-ui/core"

export const TbMuiThemeProvider = (props: ThemeProviderProps) => {
    const Provider = MuiThemeProvider as (props: any, deprecatedLegacyContext?: any) => ReactElement<any, any>
    return <Provider {...props} />
}